<app-generic-form [showBorder]="false">
  <div form-content [formGroup]="parentForm">
    <div class="d-flex justify-content-center mb-3">
      <div class="btn-group w-100" style="max-width: 480px;" role="group" aria-label="Modalità selezione luogo">
        <button
          type="button"
          class="btn d-inline-flex align-items-center justify-content-center"
          [class.btn-primary]="!_manualLocationMode()"
          [class.btn-outline-primary]="_manualLocationMode()"
          [attr.aria-pressed]="!_manualLocationMode()"
          (click)="selectSavedLocationMode()">
          <i class="bi bi-geo-alt me-1" aria-hidden="true"></i>Luoghi già salvati
        </button>
        <button
          type="button"
          class="btn d-inline-flex align-items-center justify-content-center"
          [class.btn-primary]="_manualLocationMode()"
          [class.btn-outline-primary]="!_manualLocationMode()"
          [attr.aria-pressed]="_manualLocationMode()"
          (click)="selectManualLocationMode()">
          <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Aggiungi luogo
        </button>
      </div>
    </div>

    @if (!_manualLocationMode()) {
      <div class="mt-3">
        <app-generic-search-select
          placeholder="Cerca o seleziona un luogo salvato..."
          [control]="searchControl"
          [options]="_myLocations()"
          [minSearchLength]="0"
          [displayFn]="displayMineLocation"
          (itemSelected)="locationSelected($event)"
          (deleteItem)="deleteSavedLocation($event)">
        </app-generic-search-select>

        @if (_myLocations().length === 0) {
          <div class="alert alert-info mt-3 py-2 d-flex justify-content-between align-items-center" role="alert">
            <button type="button" class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1" (click)="selectManualLocationMode()">
              <i class="bi bi-plus-lg" aria-hidden="true"></i>Aggiungi luogo
            </button>
          </div>
        }

        @if (selectedLocation) {
          <div class="card mt-3 border-primary-subtle bg-body-tertiary">
            <div class="card-body py-2 px-3 d-flex justify-content-between align-items-center">
              <div>
                <div class="fw-bold text-primary">{{ selectedLocationTitle }}</div>
                @if (selectedLocationAddress && selectedLocationAddress !== selectedLocationTitle) {
                  <div class="small text-muted">{{ selectedLocationAddress }}</div>
                }
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger ms-2 d-inline-flex align-items-center gap-1"
                (click)="clearLocation()"
                title="Deseleziona luogo">
                <i class="bi bi-trash" aria-hidden="true"></i>Rimuovi
              </button>
            </div>
          </div>
        }

      </div>
    }

    @if (_manualLocationMode()) {
      <div class="mt-3" [formGroup]="locationGroup">
        <div class="row g-3">
          @if (!organizationMode) {
            <div class="col-12">
              <label for="manualFormalName" class="form-label">
                Nome del luogo <span class="text-muted">(rinomina a tuo gusto)</span>
              </label>
              <input
                id="manualFormalName"
                type="text"
                class="form-control"
                formControlName="formalName"
                placeholder="Es. Sede associazione, Casa mia, Ludoteca Il Dado"
                (input)="onManualLocationChange()">
              <div class="form-text">Dai un nome riconoscibile a questo luogo per ritrovarlo facilmente in futuro.</div>
            </div>

            <div class="col-12 col-md-8">
              <label for="manualStreet" class="form-label">Via/Corso/Piazza</label>
              <input
                id="manualStreet"
                type="text"
                class="form-control"
                formControlName="street"
                placeholder="Es. Via Roma"
                (input)="onManualLocationChange()">
            </div>

            <div class="col-12 col-md-4">
              <label for="manualHouseNumber" class="form-label">N. civico</label>
              <input
                id="manualHouseNumber"
                type="text"
                class="form-control"
                formControlName="houseNumber"
                placeholder="Es. 10"
                (input)="onManualLocationChange()">
            </div>
          }

          <div class="col-12 col-md-8">
            <label for="manualCity" class="form-label">Città</label>
            <input
              id="manualCity"
              type="text"
              class="form-control"
              formControlName="city"
              placeholder="Es. Torino"
              (input)="onManualLocationChange()">
          </div>

          <div class="col-12 col-md-4">
            <label for="manualProvince" class="form-label">Sigla provincia</label>
            <input
              id="manualProvince"
              type="text"
              class="form-control"
              formControlName="province"
              placeholder="Es. TO"
              maxlength="2"
              (input)="onManualLocationChange()">
          </div>
        </div>

        <div class="mt-3 d-flex justify-content-center">
          <button type="button" class="btn btn-link p-0 small" (click)="selectSavedLocationMode()">
            ← Torna ai luoghi salvati
          </button>
        </div>
      </div>
    }

    @if (showRequiredLocationError) {
      <div class="alert alert-danger mt-3 mb-0" role="alert">
        Devi inserire o selezionare un luogo valido.
      </div>
    }
  </div>
</app-generic-form>
